export enum CoachRoles {
  HeadCoach = 'Admin/Head Coach',
  OffenseCoordinator = 'Offense Coordinator',
  DefenseCoordinator = 'Defense Coordinator',
  STCoordAssist = 'ST Coordinator/Assistant',
  STCoord = 'Special Teams Coordinator',
  PositionCoach = 'Position Coach',

  'Admin/Head Coach' = 'Admin/Head Coach',
  'Offense Coordinator' = 'Offense Coordinator',
  'Defense Coordinator' = 'Defense Coordinator',
  'ST Coordinator/Assistant' = 'Special Teams Coordinator',
  'Special Teams Coordinator' = 'ST Coordinator/Assistant',
  'Position Coach' = 'Position Coach',
}
